import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Rocket, Calendar, Mail } from 'lucide-react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

/**
 * A5: Employer Platform Holding Page
 * 
 * Shown to existing employer accounts when employer_platform_live is false.
 * Superadmins bypass this page and see the full dashboard.
 */
const EmployerHoldingPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" style={{ backgroundColor: 'var(--vett-navy)' }}>
      <div className="w-full max-w-2xl animate-fade-in text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <Link to="/" className="inline-flex items-center gap-3">
            <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ 
              background: 'var(--vett-coral-gradient)'
            }}>
              <Shield className="h-6 w-6 text-white" />
            </div>
            <span className="text-3xl" style={{ fontFamily: 'var(--vett-font-display)', fontWeight: 900, color: 'var(--vett-white)' }}>VETT</span>
          </Link>
        </div>

        {/* Main Card */}
        <Card className="rounded-2xl p-10" style={{ backgroundColor: 'var(--vett-surface)', border: '1px solid var(--vett-border)' }}>
          {/* Icon */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--vett-coral-dim)' }}>
            <Rocket className="h-10 w-10" style={{ color: 'var(--vett-coral)' }} />
          </div>

          {/* Title */}
          <h1 className="text-3xl mb-4" style={{ fontFamily: 'var(--vett-font-display)', fontWeight: 700, color: 'var(--vett-white)' }}>
            Your Founding Account is Ready
          </h1>

          {/* Description */}
          <p className="text-lg mb-8" style={{ fontFamily: 'var(--vett-font-body)', color: '#5B6472', maxWidth: '500px', margin: '0 auto 2rem' }}>
            Thank you for being one of our founding employers. The employer platform is in final preparation 
            and will open soon. Your account will have full access when we launch.
          </p>

          {/* Features Preview */}
          <div className="grid md:grid-cols-3 gap-4 mb-8">
            <div className="p-4 rounded-xl" style={{ backgroundColor: 'var(--vett-surface-2)' }}>
              <div className="text-2xl mb-2" style={{ color: 'var(--vett-coral)' }}>📋</div>
              <div className="text-sm" style={{ color: 'var(--vett-white-dim)' }}>Create verified work records</div>
            </div>
            <div className="p-4 rounded-xl" style={{ backgroundColor: 'var(--vett-surface-2)' }}>
              <div className="text-2xl mb-2" style={{ color: 'var(--vett-coral)' }}>🔍</div>
              <div className="text-sm" style={{ color: 'var(--vett-white-dim)' }}>Search verified talent</div>
            </div>
            <div className="p-4 rounded-xl" style={{ backgroundColor: 'var(--vett-surface-2)' }}>
              <div className="text-2xl mb-2" style={{ color: 'var(--vett-coral)' }}>✅</div>
              <div className="text-sm" style={{ color: 'var(--vett-white-dim)' }}>Instant verification checks</div>
            </div>
          </div>

          {/* Status Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ backgroundColor: 'var(--vett-coral-dim)' }}>
            <Calendar className="h-4 w-4" style={{ color: 'var(--vett-coral)' }} />
            <span style={{ fontFamily: 'var(--vett-font-mono)', fontSize: '13px', color: 'var(--vett-coral)' }}>
              Platform launch in progress
            </span>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <p className="text-sm" style={{ color: '#5B6472' }}>
              We'll notify you as soon as the platform is live.
            </p>
            <div className="flex justify-center gap-4">
              <Link to="/">
                <Button variant="outline" className="gap-2">
                  <Mail className="h-4 w-4" />
                  Return Home
                </Button>
              </Link>
            </div>
          </div>
        </Card>

        {/* Footer */}
        <p className="mt-8 text-sm" style={{ color: 'var(--vett-gray-mid)' }}>
          Questions? Contact us at <a href="mailto:support@getvett.org" style={{ color: 'var(--vett-coral)' }}>support@getvett.org</a>
        </p>
      </div>
    </div>
  );
};

export default EmployerHoldingPage;
